import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, switchMap, filter, take } from 'rxjs/operators';
import { AuthService } from '../../authentication/services/auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private _authService: AuthService) {}

  private _isRefreshingToken = false;
  private _tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  private _addTokenToRequest(request: HttpRequest<any>, token: string): HttpRequest<any> {
    return request.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err) => {
        if (err.status === 401) {
          if (this._isRefreshingToken === false) {
            this._isRefreshingToken = true;
            this._tokenSubject.next(null);

            return this._authService.refreshToken().pipe(
              switchMap((token) => {
                this._isRefreshingToken = false;
                this._tokenSubject.next(token.access_token);

                return next.handle(this._addTokenToRequest(req, token.access_token));
              })
            );
          } else {
            return this._tokenSubject.pipe(
              filter((token) => token != null),
              take(1),
              switchMap((token) => {
                return next.handle(this._addTokenToRequest(req, token));
              })
            );
          }
        }

        return throwError(err);
      })
    );
  }
}
